// extracted by mini-css-extract-plugin
export default {"video":"LazyVideoEmbed_video__QB1kN"};